import { ENDPOINTS } from '../consts';
import { AbstractApi } from '../../abstract-api';
import { GetSpecialismsResp } from '../types/specialism';
import { GetHotTopicsRespBody } from '../schema';

export class SpecialismApi extends AbstractApi {
  async getSpecialisms(): Promise<GetSpecialismsResp> {
    const axios = await this.axios();
    const { data } = await axios.get<GetSpecialismsResp>(ENDPOINTS.LEARNING.SPECIALISM.BASE);
    return data;
  }

  async getHotTopics(): Promise<GetHotTopicsRespBody> {
    const axios = await this.axios();
    const { data } = await axios.get<GetHotTopicsRespBody>(ENDPOINTS.LEARNING.HOT_TOPICS.BASE);
    return data;
  }
}
